export const isAuthenticated = (state) => {
    console.log('isAuthenticated', state.auth);
    // var data = JSON.parse(state.auth.auth);
    if (state.auth.auth.uuid) return true;
    return false;
};
